// document.getElementByclassName('video_touch'); video.control = false;

$(document).ready(function(){
$('.video_touch').each(function() {
  $(this).prop('controls', false);
  $(this).prop('autoplay', true);
  this.play(); // Force playback in case autoplay doesn't trigger immediately
});

    // partnr slider
// var isMobile = $(window).width() < 750;
//     $('.partnr_slider').owlCarousel({
//         loop:true,
//         margin:52,
//         nav:true,
//         autoplayTimeout: isMobile ? 1000 : 0,
//         responsive:{
//             0:{
//                 items:1
//             },
//             600:{
//                 items:3
//             },
//             800:{
//                 items:3,
//             },
          
//             1000:{
//                 items:6
//             }
//         }
//     });


  $('.partnr_slider').owlCarousel({
        loop:true,
        margin:52,
        nav:false,
        slideTransition: 'linear',
        autoplayTimeout: 5000,
        autoplaySpeed: 5000,
        autoplay: true, 
        smartSpeed: 2500,
        responsive:{
            0:{
                items:2.5,
                margin:10,
            },
            600:{
                items:3
            },
            800:{
                items:3,
            },
          
            1000:{
                items:6
            }
        }
    });



  // expart card slider

     $('.expart_slider').owlCarousel({
      loop: false,
      margin: 20, 
      nav: true,
      stagePadding: 0, 
      responsive: {
          0: {
              items: 1,
              stagePadding: 0 
          },
          500: {
              items: 1,
              stagePadding: 30
          },
          800: {
              items: 1,
              stagePadding: 30
          },
          900: {
              items: 2,
              stagePadding: 50
          },
          1200: {
              items: 2,
              stagePadding: 50
          },
          1300: {
              items: 3,
              stagePadding: 0
          }
        }
    });


  // bestseller slider

    // $('.bestslr-slider').owlCarousel({
    //     loop: true,
    //     margin:20,
    //     nav:true,
    //     dots:true,
    //     navText: [
    //         "<span><img src='https://cdn.shopify.com/s/files/1/0948/6503/1497/files/arrow-left-s-line.svg?v=1751456196' alt='arrow' class='left_arrow'/></span>",
    //         "<span><img src='https://cdn.shopify.com/s/files/1/0948/6503/1497/files/arrow-right-s-line.svg?v=1751456195' alt='arrow' class='right_arrow'/></span>"
    //       ],
    //     responsive:{
    //         0:{
    //             items:1.2
    //         },
    //         600:{
    //             items:2.1,
    //             touchDrag: true,
    //         },
    //        900:{
    //             items:3.1
    //         },
    //         1200:{
    //             items:4.1
    //         },
          
    //     }

    // });


   var owl = $('.bestslr-slider');

  owl.owlCarousel({
    loop: false,
    margin: 20,
    nav: true,
    dots: true,
    navText: [
      "<span><img src='https://cdn.shopify.com/s/files/1/0948/6503/1497/files/arrow-left-s-line.svg?v=1751456196' alt='arrow' class='left_arrow'/></span>",
      "<span><img src='https://cdn.shopify.com/s/files/1/0948/6503/1497/files/arrow-right-s-line.svg?v=1751456195' alt='arrow' class='right_arrow'/></span>"
    ],
    responsive:{
      0:{ items: 1 },
      600:{ items: 2, touchDrag: true },
      900:{ items: 3 },
      1200:{ items: 4 }
    },
    onInitialized: toggleNavStatus,
    onTranslated: toggleNavStatus
  });

  function toggleNavStatus(event) {
    var carousel = event.relatedTarget;
    var current = carousel.current();
    var max = carousel.maximum();

    // Disable prev
    if(current === 0) {
      $('.owl-prev').addClass('disabled');
    } else {
      $('.owl-prev').removeClass('disabled');
    }

    // Disable next
    if(current >= max) {
      $('.owl-next').addClass('disabled');
    } else {
      $('.owl-next').removeClass('disabled');
    }
  }


  

  
  // singl product slider

    $('.product-slider').owlCarousel({
        loop:true,
        margin:20,
        nav:true,
        dots:true,
        loop:false,
        navText: [
            "<i class='bi bi-chevron-left'></i>",
            "<i class='bi bi-chevron-right'></i>"
          ],
        responsive:{
            0:{
                items:1
            },
            600:{
                items:1
            },
           900:{
                items:1
            },
            1200:{
                items:1
            },
          
        }
    });


  // video review

      $('.videoreview').owlCarousel({
        loop:false,
        margin:15,
        nav:false,
        dots:false,
        loop:false,
        drag:true,
      
        responsive:{
            0:{
                items:1.2,
                dots:true,
              center:true,
            },
          
            600:{
                items:1.5
            },
            700:{
                items:2.1
            },
            1000:{
                items:3
            }
        }
    });



  // banner review

      $('.bnr-reviews').owlCarousel({
        loop:true,
        margin:0,
        nav:false,
        dots:true,
        loop:false,
      
        responsive:{
            0:{
                items:1
            },
            600:{
                items:1
            },
            1000:{
                items:1
            }
        }
    });

  $('.home_blog_slider').owlCarousel({
        loop:false,
        margin:20,
        nav:true,
        dots:true,
        rtl:false,
        slideBy:4, 
        touchDrag: true,
        mouseDrag:true,

        navText: [
            "<span class='bi bi-chevron-left'></span>",
            "<span class='bi bi-chevron-right'></span>"
          ],
        responsive:{
            0:{
                items:1
            },
            600:{
                items:2
            },
           900:{
                items:3
            },
            1200:{
                items:4,
            },
          
        }

    });


   // header calss added on scroll
      $(window).on('scroll', function() {
          if ($(this).scrollTop() > 100) {
              $('header').addClass('sticky');
          } else {
              $('header').removeClass('sticky');
          }
      }
    ); 
  
});


// counter

  $(document).ready(function() {
  function animateCounter($el) {
    let target = parseInt($el.attr('data-percent'));
    let count = 0;

    let interval = setInterval(function() {
      if(count >= target) {
        clearInterval(interval);
      } else {
        count++;
        $el.text(count + '%');
      }
    }, 30); // Adjust speed here
  }

  let hasAnimated = false;

 /* $(window).on('scroll', function() {
    let sectionTop = $('.couter-row').offset().top;
    let scrollTop = $(window).scrollTop();
    let windowHeight = $(window).height();

    if(scrollTop + windowHeight > sectionTop && !hasAnimated) {
      $('.counter').each(function() {
        animateCounter($(this));
      });
      hasAnimated = true; // Prevent re-trigger
    }
  });*/
});
    
     
      //  jQuery(document).ready(function() { 
      //    alert("hhh");
      //   let videos =  jQuery("video");
        
      //   videos.on("click", function() {
      //     // Pause all other videos
      //     videos.not(this).each(function() {
      //       this.pause();
      //       jQuery(this).parent().removeClass("playing");
      //     });
    
      //     // Toggle play/pause for the clicked video
      //     if (this.paused) {
      //       this.play();
      //       jQuery(this).parent().addClass("playing");
      //     }
      //      if (!this.paused) {
      //         this.pause();
      //      jQuery(this).parent().removeClass("playing");
      //     }
      //     else {
      //      // this.pause();
      //      jQuery(this).parent().removeClass("playing");
      //     }
      //   });
      // }); 



$(document).ready(function(){
  $("#product_greekmode").click(function(){
    $("#truncated-description, #full-description").toggle();
    $(this).toggleClass("active");
    window.dispatchEvent(new CustomEvent('show-einstein'));
  });
});



// $(document).ready(function () {
//   var html = `<span>$300</span>`;
//   $('#slidecart-checkout-form').append(html);
// });



   


$(document).ready(function() {
   $('.productSection-slider').owlCarousel(
     {
        loop:false,
        margin:20,
        nav:true,
        stagePadding: 50,
        dots:true,
        rtl:false,
        touchDrag: true,
        navText: [
            "<span><img src='https://cdn.shopify.com/s/files/1/0948/6503/1497/files/arrow-left-s-line.svg?v=1751456196' alt='arrow' class='left_arrow'/></span>",
            "<span><img src='https://cdn.shopify.com/s/files/1/0948/6503/1497/files/arrow-right-s-line.svg?v=1751456195' alt='arrow' class='right_arrow'/></span>"
          ],
        responsive:{
            0:{
                items:1,
                stagePadding: 0,
            },
            600:{
                items:2,
                stagePadding: 25,
            },
           900:{
                items:3
            },
            1200:{
                items:4
            },
          
        }
    }
   );


  $('.probitic_dream_slider').owlCarousel({
        loop:false,
        margin:20,
        nav:true,
        dots:true,
        rtl:false,
        navText: [
            "<span><img src='https://cdn.shopify.com/s/files/1/0948/6503/1497/files/arrow-left-s-line.svg?v=1751456196' alt='arrow' class='left_arrow'/></span>",
            "<span><img src='https://cdn.shopify.com/s/files/1/0948/6503/1497/files/arrow-right-s-line.svg?v=1751456195' alt='arrow' class='right_arrow'/></span>"
          ],
        responsive:{
            0:{
                items:1
            },
            600:{
                items:2
            },
           900:{
                items:2
            },
          1000:{
                items:3
            },
            1200:{
                items:4
            },
          
        }

    });
  

})


  document.addEventListener("DOMContentLoaded", () => {
        const animatedItems = document.querySelectorAll(
                ".videoreview-card,.sell-prodct-card,.coutercard,.whylv-card , .whtare-probiots-sec , .whtare , .whtare-probiots-sec .sec-titl p"
            ),
            observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        const el = entry.target,
                            delay = Array.from(animatedItems).indexOf(el) * 150;
                        entry.isIntersecting &&
                            !el.dataset.animated &&
                            ((el.dataset.animated = "true"),
                                setTimeout(() => {
                                    el.classList.add("visible");
                                }, delay));
                    });
                }, {
                    threshold: 0.1,
                    rootMargin: "0px 0px -50px 0px"
                }
            );
        animatedItems.forEach((el) => observer.observe(el));
    }),
    document.addEventListener("DOMContentLoaded", () => {
        const sections = document.querySelectorAll(
            ".family-probtn-sec, .trstd-sec, .realcustomr-sec, .why-lovebug-sec,.what-exprt-sec,.momlovel-sec,.gutbbl-sec,.bstslr-sec,.footer,.shoptoddlers-sec,#shopify-section-template--24086873538889__mfr_blog_grid_Ukgtin,.whtare-probiots-sec,.madebymon-sec,.foundation,.mom,.values,.pdpabout-sec,.shakey_shakey,.good_vs_evil,.faq,.blog,.problematic,.our_strains,.blog_hero,#shop,.faqss,.blog-grid__inner,.grid-container, .whtare-probiots-sec .whtare, .whtare-probiots-sec .sec-titl p , .whtare"
        );
        let lastScrollTop = 0;
        const observer = new IntersectionObserver(
            (entries) => {
                const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop,
                    scrollDown = currentScrollTop > lastScrollTop;
                entries.forEach((entry) => {
                        const childItems = entry.target.querySelectorAll(
                            ".videoreview-card, .sell-prodct-card, .coutercard, .whylv-card,.exprt-card,.momslv-card,.sell-prodct-card.blog-card,.bstslr-card,.updts-col h3,.updts-col p,.updts-col form,.whtare li, .whtare-probiots-sec .sec-titl p,.whtare-probiots-sec .btn-wrpr img.modl1,.whtare-probiots-sec .btn-wrpr img.truthcls,.madebymon-sec .mademom-wrpr .text-area a,.madebymon-sec .mademom-wrpr .text-area .icon1,.madebymon-sec .mademom-wrpr .text-area .icon2,.madebymon-sec .mademom-wrpr .text-area p,.bnbr-rtingtxt,.trstd-sec .common-btn,.why-lovebug-sec .sec-titl p,.why-lovebug-sec .subhding-wrpr p,.foundation h3, .foundation p,.mom-speech p,.f-logo,.heading-bottom-txt,.dreamtmcard,.value-left p,.value-list li,.values img,.pdpabout-sec p,.listwrp li,.listing li,.list-none li,.shakey_shakey button,.shakey_shakey .img-container img,.good_vs_evil .desc,.good_vs_evil img,.faq .desc,.accordion-item,.girlimage,.boyimge,.problematic .desc,.why-lovebug-sec .container-fluid .desc,.strain-card,.blog-card , .whtare-probiots-sec .whtare"
                        );
                        entry.isIntersecting &&
                            scrollDown &&
                            childItems.forEach((el, i) => {
                                el.classList.remove("visible"),
                                    setTimeout(() => {
                                        el.classList.add("visible");
                                    }, i * 200);
                            }),
                            !entry.isIntersecting &&
                            !scrollDown &&
                            childItems.forEach((el) => {
                                el.classList.remove("visible");
                            });
                    }),
                    (lastScrollTop = Math.max(currentScrollTop, 0));
            }, {
                threshold: 0.2
            }
        );
        sections.forEach((sec) => observer.observe(sec));
    });

